import * as React from 'react';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import {dismissMessage} from '../model/feedback';
import {connect} from 'react-redux';


class ToastsProps {
    messages: any;
    dispatch: Function;
    textForKey: Function;
}

@connect(state => ({
    textForKey: state.data.textForKey
}))
export class Toasts extends React.Component<any, any> {
    render() {
        let {messages, dispatch, textForKey} = this.props;
        return (
            <div className="toasts">
                <CSSTransitionGroup transitionName="toast" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                {messages.map((message, i) => {
                    let {text, type} = message;
                    let onDismiss = () => dispatch(dismissMessage(i));
                    let toastProps = {key: i, type, onDismiss};
                    return <Toast {...toastProps}>{textForKey(text)}</Toast>;
                })}
                </CSSTransitionGroup>
            </div>
        );
    }
}


export class Toast extends React.Component<any, any> {
    render() {
        let {onDismiss, type, children} = this.props;

        return (
            <div className="toast">
                <div className={`alert alert-${type}`}>
                <button type="button" className="close" aria-label="Close" onClick={onDismiss}>
                    <span aria-hidden="true">&times;</span>
                </button>
                {children}
                </div>
            </div>
        )
    }
}
